import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Button } from "@repo/ui";
import { withTranslations } from "../../../../hoc/withTranslations/withTranslations";
import withAuth from "../../../../hoc/withAuth/withAuth";
import AnimatedCard from "../../../../components/AnimatedCard/AnimatedCard";
import PageContainer from "../../../../components/PageContainer/PageContainer";
import Confetti from "../../../../components/Confetti/Confetti";
import StepIndicator from "../../../../components/StepIndicator/StepIndicator";
import { registrationSteps } from "../../constants/steps";
import { getPhoto } from "../../../../utils/indexedDB";

const LOCALE = "modules_Registration_pages_Success_Success";

const Success: React.FC = () => {
  const { t } = useTranslation(LOCALE);
  const navigate = useNavigate();
  const [photo, setPhoto] = useState<string | null>(null);

  useEffect(() => {
    (async () => {
      const savedPhoto = await getPhoto("giftTablePhoto");
      if (savedPhoto) {
        setPhoto(savedPhoto);
      }
    })();
  }, []);

  const handleAddGifts = () => {
    navigate("/my-table");
  };

  return (
    <PageContainer>
      <StepIndicator
        steps={registrationSteps}
        currentStep={7}
        progressPercentage={100}
      />
      <Confetti />
      <AnimatedCard
        title={t("title")}
        className="bg-white max-w-lg w-full text-center"
      >
        <div className="flex justify-center mb-4">
          <div className="relative w-64 h-64 rounded-full overflow-hidden">
            <img
              src={photo || ""}
              alt="Event"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
        <Button
          label={t("addGiftsButton")}
          onClick={handleAddGifts}
          type="primary"
          className="w-full mt-4"
        />
      </AnimatedCard>
    </PageContainer>
  );
};

export default withAuth(withTranslations(LOCALE)(Success));
